module.exports = __webpack_public_path__ + "fonts/Montserrat-Medium.3a09173.ttf";